import React, { useEffect, useRef } from 'react';

import { StyleProp, Text, TextStyle, View, ViewStyle } from 'react-native';

import { useTranslation } from 'react-i18next';
import { getBaseOs } from 'react-native-device-info';

import { RBProgram } from 'store/railsBuilder/reducer.types';
import {
    CachedRecordingItem,
    RecordingMetadata,
} from 'store/recordings/reducer.types';

import { VodEditorial } from 'services/data-manager/types';

import { heightPercentageToDP } from 'utils/responsiveness';

import styles from './styles';

function DetailPageSubTitle({
    item,
    recordingItem,
    containerStyle,
    titleStyle,
}: {
    item: RBProgram | VodEditorial | RecordingMetadata;
    recordingItem: CachedRecordingItem | undefined;
    containerStyle?: StyleProp<ViewStyle>;
    titleStyle?: TextStyle;
}) {
    const { t } = useTranslation();
    const operatingSystem = useRef('');

    const hasEpisodeNumber = !!item.episodeNumber;
    const hasSeasonNumber = !!item.SeasonNumber;
    const canDisplaySubtitle =
        (item as RBProgram | VodEditorial).EpisodeTitle ||
        (item as RBProgram | VodEditorial).Episode ||
        (item as RecordingMetadata).episode ||
        hasEpisodeNumber ||
        hasSeasonNumber;

    useEffect(() => {
        getBaseOs().then((baseOs) => {
            operatingSystem.current = baseOs;
        });
    }, []);

    return (
        <View
            style={[
                styles.container,
                containerStyle,
                !canDisplaySubtitle && {
                    marginBottom: heightPercentageToDP(16, 16),
                },
            ]}
        >
            {canDisplaySubtitle && (
                <Text
                    style={[
                        styles.title,
                        titleStyle,
                        {
                            lineHeight:
                                operatingSystem.current === 'Windows' ? 40 : 24,
                        },
                    ]}
                    numberOfLines={1}
                    ellipsizeMode="tail"
                >
                    {!!(
                        (item as RBProgram | VodEditorial).seriesRef ||
                        recordingItem?.seriesId
                    ) && (
                        <>
                            {hasSeasonNumber && (
                                <Text>
                                    {`${t('HOVER_SEASON')}${
                                        item.SeasonNumber
                                    } `}
                                </Text>
                            )}
                            {hasEpisodeNumber && (
                                <Text>
                                    {`${t('HOVER_EPISODE')}${
                                        item.episodeNumber
                                    } `}
                                </Text>
                            )}
                        </>
                    )}
                    {(item as RBProgram | VodEditorial).EpisodeTitle ||
                        (item as RBProgram | VodEditorial).Episode ||
                        (item as RecordingMetadata).episode}
                </Text>
            )}
        </View>
    );
}

export default DetailPageSubTitle;
